export const choosePackage = {
	continue: {
		sv: "Fortsätt",
	},
	back: { sv: "Tillbaka" },
	totalAmount: { sv: "Totalsumma" },
	heading: {
		sv: "Hej företagare!",
	},
	subHeading: {
		sv: "Vi hjälper företagare att komma igång och kan ge den där extra skjutsen för att växa.",
	},
	subHeading2: {
		sv: "Välj det paket som passar och lägg till extra kort och krediter du vill ha.",
	},
	stepTitle: {
		sv: "Välj paket",
	},
	otherPackagesTitle: {
		sv: "Våra andra paket",
	},
	creditSummation: {
		title: {
			sv: "Din kreditpott",
		},
		description: {
			sv: "Du kan använda potten till kontokredit eller kreditkort.",
		},
		unavailable: {
			sv: "I dagsläget kan vi inte erbjuda dig våra kreditprodukter.",
		},
	},
	packageSelected: {
		sv: "Du har valt {0}",
	},
	selectLabel: {
		sv: "Välj {0}",
	},
	"FÖRETAGARNA-BAS": {
		preTitle: {
			sv: "Företagarna",
		},
		title: {
			sv: "Företagarna",
		},
		targetGroup: {
			sv: "Medlemspaket",
		},
		moreAbout: {
			sv: "Mer om Svea och Företagarna",
		},
		desktop: {
			description: {
				sv: "De viktigaste banktjänsterna för startup och småföretagare till ett bra pris. Företagskontot som är navet i din verksamhet kopplas till ett bankkort och ett nytt eller befintligt bankgironummer.",
			},
			bullet1: {
				sv: "Företagarna bankkort",
			},
			bullet2: {
				sv: "Sparkonto med ränta",
			},
			bullet3: {
				sv: "Medlemsförmåner på kortet",
			},
			bullet4: {
				sv: "Bankgironummer",
			},
			bullet5: {
				sv: "Företagskonto",
			},
		},
		mobile: {
			description: {
				sv: "De viktigaste banktjänsterna för startup och småföretagare till ett bra pris. Företagskontot som är navet i din verksamhet kopplas till ett bankkort och ett nytt eller befintligt bankgironummer.",
			},
			bullet1: {
				sv: "Svea bankkort",
			},
			bullet2: {
				sv: "Företagskonto",
			},
			bullet3: {
				sv: "Sparkonto med ränta",
			},
		},

		externalLink: {
			sv: "https://www.svea.com/sv-se/foretag/f%C3%B6retagsbanken/kontokredit",
		},
		promo: {
			sv: "För dig som är medlem i Företagarna",
		},
		promoMobile: {
			sv: "Medlem i Företagarna",
		},
	},
	"FORETAGARNA-CARDONLY": {
		preTitle: {
			sv: "Företagarna",
		},
		title: {
			sv: "Företagarna kreditkort",
		},
		targetGroup: {
			sv: "Medlemserbjudande",
		},
		moreAbout: {
			sv: "Mer om Svea och Företagarna",
		},
		desktop: {
			description: {
				sv: "Ansök om upp till 1 miljon kronor i kredit online. Reseförsäkring och tillgång till flygplatslounger världen över ingår. Inom kort laddar vi på utvalda förmåner från Företagarna.",
			},
			bullet1: {
				sv: "Räntefritt upp till 45 dagar",
			},
			bullet2: {
				sv: "Koppla till ditt utläggssystem",
			},
			bullet3: {
				sv: "Inga valutapåslag eller uttagsavgifter",
			},
			bullet4: {
				sv: "Flygplatslounger och reseförsäkring",
			},
		},
		mobile: {
			description: {
				sv: "Ansök om upp till 1 miljon kronor i kredit online. Reseförsäkring och tillgång till flygplatslounger världen över ingår. Inom kort laddar vi på utvalda förmåner från Företagarna.",
			},
			bullet1: {
				sv: "Räntefritt upp till 45 dagar",
			},
			bullet2: {
				sv: "Koppla till ditt utläggssystem",
			},
			bullet3: {
				sv: "Inga valutapåslag eller uttagsavgifter",
			},
			bullet4: {
				sv: "Flygplatslounger och reseförsäkring",
			},
		},

		externalLink: {
			sv: "https://www.svea.com/sv-se/foretag/f%C3%B6retagsbanken/f%C3%B6retagarna-och-svea",
		},
		promo: {
			sv: "För dig som är medlem i Företagarna",
		},
		promoMobile: {
			sv: "Medlem i Företagarna",
		},
	},
	"E-HANDEL-BAS": {
		preTitle: {
			sv: "E-handel",
		},
		title: {
			sv: "E-handel",
		},
		targetGroup: {
			sv: "Företagspaket",
		},

		desktop: {
			description: {
				sv: "De viktigaste banktjänsterna och Svea Checkout, en komplett betallösning som erbjuder alla efterfrågade betalsätt för maximal konvertering.",
			},
			bullet1: {
				sv: "Svea Checkout betallösning ",
			},
			bullet2: {
				sv: "Svea bankkort",
			},
			bullet3: {
				sv: "Företagskonto",
			},
			bullet4: {
				sv: "Bankgironummer",
			},
			bullet5: {
				sv: "Sparkonto med ränta",
			},
		},
		mobile: {
			description: {
				sv: "De viktigaste banktjänsterna och Svea Checkout, en komplett betallösning som erbjuder alla efterfrågade betalsätt för maximal konvertering.",
			},
			bullet1: {
				sv: "Svea Checkout betallösning ",
			},
			bullet2: {
				sv: "Företagskonto och sparkonto",
			},
			bullet3: {
				sv: "Svea bankkort",
			},
		},

		externalLink: {
			sv: "https://www.svea.com/sv-se/foretag/betallosningar/e-handel",
		},
		promo: {
			sv: "Företag som säljer och tar betalt online",
		},
		promoMobile: {
			sv: "För din e-handel",
		},
		terms: {
			sv: "För Svea Checkout tillkommer transaktionsavgiften 2,95 % per slutförd order.",
		},
	},
	"BAAS-FÖRETAG-BAS": {
		preTitle: {
			sv: "Företag",
		},
		title: {
			sv: "Bas",
		},
		targetGroup: {
			sv: "Företagspaket",
		},

		desktop: {
			description: {
				sv: "De viktigaste banktjänsterna för startup och småföretagare till ett bra pris. Företagskontot som är navet i din verksamhet kopplas till ett bankkort och ett nytt eller befintligt bankgironummer.",
			},
			bullet1: {
				sv: "Passar småföretagare",
			},
			bullet2: {
				sv: "Svea Bankkort",
			},
			bullet3: {
				sv: "Företagskonto",
			},
			bullet4: {
				sv: "Bankgironummer",
			},
			bullet5: {
				sv: "Sparkonto med ränta",
			},
		},
		mobile: {
			description: {
				sv: "De viktigaste banktjänsterna för startup och småföretagare till ett bra pris.",
			},
			bullet1: {
				sv: "Svea bankkort",
			},
			bullet2: {
				sv: "Företagskonto",
			},
			bullet3: {
				sv: "Sparkonto med ränta",
			},
		},

		externalLink: {
			sv: "https://www.svea.com/sv-se/foretag/f%C3%B6retagsbanken/f%C3%B6retag-bas",
		},
		promo: {
			sv: "Passar småföretagare",
		},
		promoMobile: {
			sv: "Småföretagare",
		},
	},
	"BAAS-FÖRETAG-VÄXA": {
		preTitle: {
			sv: "Företag",
		},
		title: {
			sv: "Växa",
		},
		targetGroup: {
			sv: "Företagspaket",
		},

		desktop: {
			description: {
				sv: "Ger ditt företag köpkraft och stabilare kassaflöden för att kunna investera, anställa och växa. Kontokredit på upp till 1 miljon kronor ingår, med möjlighet att utöka mot en extra kostnad.",
			},
			bullet1: {
				sv: "För företag med anställda",
			},
			bullet2: {
				sv: "Svea kreditkort",
			},
			bullet3: {
				sv: "Företagskonto med kredit",
			},
			bullet4: {
				sv: "Svea bankkort",
			},
			bullet5: {
				sv: "Sparkonto med ränta",
			},
			bullet6: {
				sv: "Bankgironummer",
			},
		},
		mobile: {
			description: {
				sv: "Ger ditt företag köpkraft och stabilare kassaflöden för att kunna investera, anställa och växa.",
			},
			bullet1: {
				sv: "Företagskonto med kredit",
			},
			bullet2: {
				sv: "Sparkonto med ränta",
			},
			bullet3: {
				sv: "Svea kreditkort och bankkort",
			},
		},

		externalLink: {
			sv: "https://www.svea.com/sv-se/foretag/f%C3%B6retagsbanken/f%C3%B6retag-v%C3%A4xa",
		},
		promo: {
			sv: "För företag med anställda",
		},
		promoMobile: {
			sv: "Företag med anställda",
		},
	},

	OVERDRAFTPACKAGE: {
		preTitle: {
			sv: "Företag",
		},
		title: {
			sv: "Finansiera",
		},
		targetGroup: {
			sv: "Företagspaket",
		},
		moreAbout: {
			sv: "Mer om kontokredit",
		},

		desktop: {
			description: {
				sv: "Flexibel kontokredit förbättrar likviditeten och ger ditt företag stabilitet. Online kan du ansöka om upp till 1 miljon kronor i kredit och få svar direkt. Du betalar bara ränta på krediten om den används.",
			},
			bullet1: {
				sv: "Företagskonto med kredit",
			},
			bullet2: {
				sv: "Betala för det du använder",
			},
			bullet3: {
				sv: "Ansök om 1 000 000 kr online",
			},
			bullet4: {
				sv: "Bankgironummer",
			},
		},
		mobile: {
			description: {
				sv: "Flexibel kontokredit förbättrar likviditeten och ger ditt företag stabilitet. Online kan du ansöka om upp till 1 miljon kronor i kredit och få svar direkt. Du betalar bara ränta på krediten om den används.",
			},
			bullet1: {
				sv: "Företagskonto med kredit",
			},
			bullet2: {
				sv: "Betala för det du använder",
			},
			bullet3: {
				sv: "Ansök om 1 000 000 kr online",
			},
		},

		externalLink: {
			sv: "https://www.svea.com/sv-se/foretag/f%C3%B6retagsbanken/kontokredit",
		},
	},

	packageBlock: {
		content: {
			sv: "",
		},
		title1: {
			sv: "Företagskonto",
		},
		title2: {
			sv: "Ett Svea Bankkort",
		},
		title3: {
			sv: "Ett sparkonto med ränta",
		},
		title4: {
			sv: "Bankgironummer",
		},
		terms: {
			sv: "Banktjänsterna har ingen bindningstid och du kan byta paket senare.",
		},
		eHandelterms: {
			sv: "För Svea Checkout tillkommer transaktionsavgiften 2,95 % per slutförd order.",
		},
		unavailable: {
			sv: "Just nu kan du inte välja detta paket.",
		},
		smartChoice: {
			sv: "Smart val",
		},
	},
	companyAccount: {
		heading: {
			sv: "Bankgiro",
		},
		description: {
			sv: "Bankgironummer ingår i alla våra paket. Koppla det till ditt nya företagskonto antingen genom att flytta över det från en annan bank (tar 2-3 dagar) eller få ett nytt bankgironummer nu.",
		},
		subheading: {
			sv: "Vill du lägga till bankgironummer?",
		},
		tooltip: {
			sv: "Väljer du att inte koppla ett bankgiro till ditt konto kan du göra det senare. Lägg till tjänsten under tilläggsprodukter i internetbanken.",
		},
		answer1: {
			sv: "Ja, flytta över från en annan bank",
		},
		answer2: {
			sv: "Ja, jag vill ha ett nytt",
		},
		answer3: {
			sv: "Nej tack",
		},
		inputLabel: {
			sv: "Bankgironummer",
		},
	},
	tooltip: {
		description: {
			sv: "**Vill du ha mer kreditutrymme?** \n\nNär du blivit kund i banken har du möjlighet att öka ditt kreditutrymme. Kontakta vår kundtjänst så hjälper de dig se över dina möjligheter",
		},
	},
	externalLink: {
		link: {
			sv: "https://www.svea.com/sv-se/foretag/f%C3%B6retagsbanken/",
		},
		description: {
			sv: "Läs mer om våra paket och produkter",
		},
	},
};
